import { render } from "./AntifraudPage.vue?vue&type=template&id=4b589971"
import script from "./AntifraudPage.vue?vue&type=script&lang=js"
export * from "./AntifraudPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__